"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpCode = /** @class */ (function () {
    function HttpCode() {
    }
    HttpCode.OK = 200;
    HttpCode.Created = 201;
    HttpCode.Accepted = 202;
    HttpCode.NoContent = 204;
    HttpCode.Unauthorized = 401;
    HttpCode.Forbidden = 403;
    HttpCode.Redirect = 404;
    HttpCode.TooManyRequests = 429;
    HttpCode.InternalServerError = 500;
    HttpCode.ServiceUnavailable = 503;
    HttpCode.NotFound = 729;
    return HttpCode;
}());
exports.default = HttpCode;
//# sourceMappingURL=HttpCode.js.map